// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as LumiOption from "./LumiOption.res.js";
import * as LumiResult from "./LumiResult.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as Belt_MapInt from "@rescript/runtime/lib/es6/Belt_MapInt.js";
import * as StringCodec from "./StringCodec.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Belt_MapString from "@rescript/runtime/lib/es6/Belt_MapString.js";
import * as Belt_SetString from "@rescript/runtime/lib/es6/Belt_SetString.js";
import * as Stdlib_JsError from "@rescript/runtime/lib/es6/Stdlib_JsError.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";

function encodeString(__x) {
  return Jzon.encode(Jzon.string, __x);
}

function decodeString(__x) {
  return Jzon.decode(Jzon.string, __x);
}

function encodeFloat(__x) {
  return Jzon.encode(Jzon.float, __x);
}

function decodeFloat(__x) {
  return Jzon.decode(Jzon.float, __x);
}

function encodeInt(__x) {
  return Jzon.encode(Jzon.int, __x);
}

function decodeInt(__x) {
  return Jzon.decode(Jzon.int, __x);
}

function encodeBool(__x) {
  return Jzon.encode(Jzon.bool, __x);
}

function decodeBool(__x) {
  return Jzon.decode(Jzon.bool, __x);
}

function tuple2(elementCodec1, elementCodec2) {
  return Jzon.custom(param => [
    Jzon.encodeWith(param[0], elementCodec1),
    Jzon.encodeWith(param[1], elementCodec2)
  ], json => {
    if (Array.isArray(json) && json.length === 2) {
      let elemJson1 = json[0];
      let elemJson2 = json[1];
      let match = Jzon.decodeWith(elemJson1, elementCodec1);
      let match$1 = Jzon.decodeWith(elemJson2, elementCodec2);
      if (match.TAG === "Ok") {
        if (match$1.TAG === "Ok") {
          return {
            TAG: "Ok",
            _0: [
              match._0,
              match$1._0
            ]
          };
        } else {
          return {
            TAG: "Error",
            _0: match$1._0
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: match._0
        };
      }
    }
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "array[2]",
          json
        ]
      }
    };
  });
}

function tuple3(elementCodec1, elementCodec2, elementCodec3) {
  return Jzon.custom(param => [
    Jzon.encodeWith(param[0], elementCodec1),
    Jzon.encodeWith(param[1], elementCodec2),
    Jzon.encodeWith(param[2], elementCodec3)
  ], json => {
    if (Array.isArray(json) && json.length === 3) {
      let elemJson1 = json[0];
      let elemJson2 = json[1];
      let elemJson3 = json[2];
      let match = Jzon.decodeWith(elemJson1, elementCodec1);
      let match$1 = Jzon.decodeWith(elemJson2, elementCodec2);
      let match$2 = Jzon.decodeWith(elemJson3, elementCodec3);
      if (match.TAG === "Ok") {
        if (match$1.TAG === "Ok") {
          if (match$2.TAG === "Ok") {
            return {
              TAG: "Ok",
              _0: [
                match._0,
                match$1._0,
                match$2._0
              ]
            };
          } else {
            return {
              TAG: "Error",
              _0: match$2._0
            };
          }
        } else {
          return {
            TAG: "Error",
            _0: match$1._0
          };
        }
      } else {
        return {
          TAG: "Error",
          _0: match._0
        };
      }
    }
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "array[3]",
          json
        ]
      }
    };
  });
}

let unit = Jzon.custom(() => [], json => {
  if (Array.isArray(json) && json.length === 0) {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonType",
      VAL: [
        [],
        "[]",
        json
      ]
    }
  };
});

function iso(codecA, aToB, bToA) {
  return Jzon.custom(valueB => Jzon.encodeWith(bToA(valueB), codecA), json => Stdlib_Result.map(Jzon.decodeWith(json, codecA), aToB));
}

function stringCodec(sc) {
  return Jzon.custom(v => Jzon.encodeWith(sc.toString(v), Jzon.string), json => Stdlib_Result.flatMap(Jzon.decodeWith(json, Jzon.string), str => LumiOption.okOr(sc.fromString(str), {
    NAME: "UnexpectedJsonValue",
    VAL: [
      [],
      str
    ]
  })));
}

function decodeField(fields, fieldName, fieldCodec) {
  return Stdlib_Option.mapOr(fields[fieldName], {
    TAG: "Error",
    _0: {
      NAME: "MissingField",
      VAL: [
        [],
        fieldName
      ]
    }
  }, fieldJson => Jzon.decodeWith(fieldJson, fieldCodec));
}

function inlineRecordSum(encode, decode, tagFieldNameOpt) {
  let tagFieldName = tagFieldNameOpt !== undefined ? tagFieldNameOpt : "tag";
  return Jzon.custom(value => {
    let match = encode(value);
    let fieldsDict = Object.fromEntries(match[1]);
    fieldsDict[tagFieldName] = Jzon.encodeWith(match[0], Jzon.string);
    return fieldsDict;
  }, json => Stdlib_Result.flatMap(Jzon.asObject(json), fields => Stdlib_Result.flatMap(decodeField(fields, tagFieldName, Jzon.string), __x => decode(__x, fields))));
}

function taggedVariant(encode, decode, tagFieldNameOpt, contentsFieldNameOpt) {
  let tagFieldName = tagFieldNameOpt !== undefined ? tagFieldNameOpt : "tag";
  let contentsFieldName = contentsFieldNameOpt !== undefined ? contentsFieldNameOpt : "contents";
  return Jzon.object2(encode, decode, Jzon.field(tagFieldName, Jzon.string), Jzon.field(contentsFieldName, Jzon.json));
}

function taggedVariantOptionalContents(encode, decode, tagFieldNameOpt, contentsFieldNameOpt) {
  let tagFieldName = tagFieldNameOpt !== undefined ? tagFieldNameOpt : "tag";
  let contentsFieldName = contentsFieldNameOpt !== undefined ? contentsFieldNameOpt : "contents";
  return Jzon.object2(encode, decode, Jzon.field(tagFieldName, Jzon.string), Jzon.optional(Jzon.field(contentsFieldName, Jzon.json)));
}

function singleConstructor(singleValue) {
  return Jzon.custom(value => {
    if (Primitive_object.equal(value, singleValue)) {
      return [];
    } else {
      return Stdlib_JsError.panic("Received different value than the specified single constructor");
    }
  }, json => {
    if (Array.isArray(json) && json.length === 0) {
      return {
        TAG: "Ok",
        _0: singleValue
      };
    }
    return {
      TAG: "Error",
      _0: {
        NAME: "UnexpectedJsonType",
        VAL: [
          [],
          "[]",
          json
        ]
      }
    };
  });
}

function sumAsString(pairs) {
  return stringCodec(StringCodec.sumAsString(pairs));
}

function anySumAsString(values, modifyOpt) {
  let modify = modifyOpt !== undefined ? modifyOpt : s => s;
  return stringCodec(StringCodec.anySumAsString(values, modify));
}

let KeyCodec = {};

function keyCustom(encode, decode) {
  return {
    encode: encode,
    decode: decode
  };
}

function keyJson(jsonCodec) {
  return {
    encode: {
      TAG: "ToJsonKeyValue",
      _0: v => Jzon.encodeWith(v, jsonCodec)
    },
    decode: {
      TAG: "FromJsonKeyValue",
      _0: json => Jzon.decodeWith(json, jsonCodec)
    }
  };
}

function keyValuePairs(valuesCodec) {
  return Jzon.custom(pairs => Object.fromEntries(pairs.map(param => [
    param[0],
    Jzon.encodeWith(param[1], valuesCodec)
  ])), json => Stdlib_Result.flatMap(Jzon.asObject(json), obj => {
    let match = Belt_Array.unzip(Object.entries(obj).map(param => {
      let key = param[0];
      return [
        key,
        Stdlib_Result.mapError(Jzon.decodeWith(param[1], valuesCodec), __x => Jzon.DecodingError.prependLocation(__x, {
          TAG: "Field",
          _0: key
        }))
      ];
    }));
    let keys = match[0];
    return Stdlib_Result.map(LumiResult.sequence(match[1]), vals => Belt_Array.zip(keys, vals));
  }));
}

function map(keyCodec, valuesCodec, id) {
  let keyEncode = keyCodec.encode;
  if (keyEncode.TAG === "ToJsonKeyString") {
    let keyDecode = keyCodec.decode;
    let keyEncode$1 = keyEncode._0;
    if (keyDecode.TAG === "FromJsonKeyString") {
      let keyDecode$1 = keyDecode._0;
      let encode = map => Object.fromEntries(Belt_Map.toArray(map).map(param => [
        keyEncode$1(param[0]),
        Jzon.encodeWith(param[1], valuesCodec)
      ]));
      let decode = json => Stdlib_Result.map(Stdlib_Result.flatMap(Jzon.asObject(json), dict => LumiResult.sequence(Object.entries(dict).map(param => LumiResult.sequence2([
        keyDecode$1(param[0]),
        Jzon.decodeWith(param[1], valuesCodec)
      ])))), res => Belt_Map.fromArray(res, id));
      return Jzon.custom(encode, decode);
    }
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "invalid codec",
      Error: new Error()
    };
  }
  let keyDecode$2 = keyCodec.decode;
  if (keyDecode$2.TAG === "FromJsonKeyString") {
    throw {
      RE_EXN_ID: "Invalid_argument",
      _1: "invalid codec",
      Error: new Error()
    };
  }
  let keyCodec$1 = Jzon.custom(keyEncode._0, keyDecode$2._0);
  let mapCodec = Jzon.array(tuple2(keyCodec$1, valuesCodec));
  let encode$1 = map => Jzon.encodeWith(Belt_Map.toArray(map), mapCodec);
  let decode$1 = json => Stdlib_Result.map(Jzon.decodeWith(json, mapCodec), res => Belt_Map.fromArray(res, id));
  return Jzon.custom(encode$1, decode$1);
}

function mapString(valuesCodec) {
  let arrayCodec = keyValuePairs(valuesCodec);
  return Jzon.custom(map => Jzon.encodeWith(Belt_MapString.toArray(map), arrayCodec), json => Stdlib_Result.map(Jzon.decodeWith(json, arrayCodec), Belt_MapString.fromArray));
}

function mapInt(valuesCodec) {
  return Jzon.custom(map => Object.fromEntries(Belt_MapInt.toArray(map).map(param => [
    param[0].toString(),
    Jzon.encodeWith(param[1], valuesCodec)
  ])), json => Stdlib_Result.map(Stdlib_Result.flatMap(Jzon.asObject(json), dict => LumiResult.sequence(Object.entries(dict).map(param => LumiResult.sequence2([
    LumiOption.okOr(Stdlib_Int.fromString(param[0], undefined), {
      NAME: "UnexpectedJsonValue",
      VAL: [
        [],
        "not an int"
      ]
    }),
    Jzon.decodeWith(param[1], valuesCodec)
  ])))), Belt_MapInt.fromArray));
}

function set(valueCodec, id) {
  return Jzon.custom(set => Jzon.encodeWith(Belt_Set.toArray(set), Jzon.array(valueCodec)), json => Stdlib_Result.map(Jzon.decodeWith(json, Jzon.array(valueCodec)), x => Belt_Set.fromArray(x, id)));
}

let setString = Jzon.custom(set => Jzon.encodeWith(Belt_SetString.toArray(set), Jzon.array(Jzon.string)), json => Stdlib_Result.map(Jzon.decodeWith(json, Jzon.array(Jzon.string)), Belt_SetString.fromArray));

export {
  encodeString,
  decodeString,
  encodeFloat,
  decodeFloat,
  encodeInt,
  decodeInt,
  encodeBool,
  decodeBool,
  tuple2,
  tuple3,
  unit,
  iso,
  stringCodec,
  decodeField,
  inlineRecordSum,
  taggedVariant,
  taggedVariantOptionalContents,
  singleConstructor,
  sumAsString,
  anySumAsString,
  KeyCodec,
  keyCustom,
  keyJson,
  keyValuePairs,
  map,
  mapString,
  mapInt,
  set,
  setString,
}
/* unit Not a pure module */
